import { FC } from 'react';
import cn from 'classnames';
import { Icon } from '@src/components/icon/Icon';

interface PlayComponentProps {
  className?: string;
  children?: React.ReactNode;
  style?: React.CSSProperties;
}
export const PlayComponent: FC<PlayComponentProps>  = ({ className, children, ...props }) => {
  return (
    <div
      className={
        cn([ className,
          "flex rounded-md bg-transparent justify-center items-end pointer cursor-auto",
        ])
      }
      style={props.style}
    >
      <div className="rounded-2xl">
        <Icon type="play" size="large" />
        {children}
      </div>
    </div>
  );
};
